import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import UiBtn from "@/plugins/ui/components/button/UiBtn.vue";
import { computed, ref } from "vue";
import UiModalPage from "@/components/ui/UiModalPage.vue";
import UiModalPageHeader from "@/components/ui/UiModalPageHeader.vue";
import UiModalPageHeaderClose from "@/components/ui/UiModalPageHeaderClose.vue";
import UiTextField from "@/components/ui/UiTextField.vue";
import { useAsync } from "@/use/useAsync";
import { useScore } from "@/use/useScore";
import UiCell from "@/plugins/ui/components/cell/UiCell.vue";
import UiSwitch from "@/components/ui/UiSwitch.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SetLimitModal',
  setup(__props) {

const { limit, upateLimit } = useScore();

const showModal = ref(false);
const newLimit = ref(0);

const hasLimit = computed({
  get: () => limit.value.limit > -1 || newLimit.value > -1,
  set: (value) => (value ? (newLimit.value = 0) : (newLimit.value = -1)),
});

const handleUpdateLimit = useAsync(async () => {
  await upateLimit(
    newLimit.value === -1 ? newLimit.value : newLimit.value * 100
  );
  showModal.value = false;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(UiBtn, _mergeProps(_ctx.$attrs, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true)),
      variant: "secondary"
    }), {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(limit).limit === -1 ? "Установить лимит" : "Изменить лимит"), 1)
      ]),
      _: 1
    }, 16),
    _createVNode(UiModalPage, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((showModal).value = $event))
    }, {
      header: _withCtx(() => [
        _createVNode(UiModalPageHeader, null, {
          before: _withCtx(() => [
            _createVNode(UiModalPageHeaderClose, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showModal.value = false))
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_unref(limit).limit === -1 ? "Установка лимита" : "Изменение лимита"), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(handleUpdateLimit).execute()), ["prevent"]))
        }, [
          _createVNode(UiCell, {
            title: "Установить лимит",
            class: "-mx-2"
          }, {
            right: _withCtx(() => [
              _createVNode(UiSwitch, {
                modelValue: _unref(hasLimit),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(hasLimit) ? (hasLimit).value = $event : null)),
                value: _unref(hasLimit)
              }, null, 8, ["modelValue", "value"])
            ]),
            _: 1
          }),
          (newLimit.value > -1)
            ? (_openBlock(), _createBlock(UiTextField, {
                key: 0,
                modelValue: newLimit.value,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newLimit).value = $event)),
                type: "number",
                step: "0.01",
                placeholder: "0.00",
                label: "Величина лимита"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createVNode(UiBtn, {
            loading: _unref(handleUpdateLimit).isPending.value,
            disabled: _unref(handleUpdateLimit).isPending.value,
            block: "",
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(!_unref(hasLimit)
              ? "Удалить лимит"
              : _unref(limit).limit === -1
              ? "Установить лимит"
              : "Изменить лимит"), 1)
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ], 32)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})